import React from 'react'
import ModulatorsStore from "../stores/ModulatorsStore";
import MidiStore from "../stores/MidiStore";
import PresetsStore from "../stores/PresetsStore";

export const storesContext = React.createContext({
    midiStore: MidiStore,
    modulatorsStore: ModulatorsStore,
    presetsStore: PresetsStore
});
